module.exports = __webpack_public_path__ + "img/dubai-szr.c78ff98b.jpg";